<!--
 * @Author: DY
 * @Date: 2023-11-30 11:40:05
 * @LastEditTime: 2024-09-06 15:27:31
 * @Description:
 * @FilePath: \ShiMo_Mobile\src\views\reportForm\miningDaily\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="hljDailyProductionReport">
            <nav-bar-box :extr="navData"></nav-bar-box>
            <div class="accountsReceive">
                <timeNodeFiltering ref="timeNodeFiltering" @selectNodeCallback="getData"></timeNodeFiltering>
                <div class="main">
                    <div class="statisticsStyle1">
                        <div class="header">
                            <div class="item">
                                <p class="describe2">
                                    总量
                                </p>
                                <p class="num2">
                                    {{ totalVal.total_output }}
                                </p>
                            </div>
                            <div class="item">
                                <p class="describe2">
                                    剥离量
                                </p>
                                <p class="num2">
                                    {{ totalVal.stripping_output }}
                                </p>
                            </div>
                            <div class="item">
                                <p class="describe2">
                                    矿石量
                                </p>
                                <p class="num2">
                                    {{ totalVal.ore_total_output }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="statisticsStyle2">
                        <div class="item">
                            <p class="describe2">
                                剥离比：
                            </p>
                            <p class="num2">
                                {{ totalVal.stripping_ratio }}%
                            </p>
                        </div>
                        <div class="item">
                            <p class="describe2">
                                一级品比例：
                            </p>
                            <p class="num2">
                                {{ totalVal.first_grade_ratio }}%
                            </p>
                        </div>
                    </div>
                    <div class="chart-con">
                        <div id="balance-chart"></div>
                    </div>
                    <div class="tableBox">
                        <table>
                            <thead>
                                <tr>
                                    <th rowspan="2">
                                        矿石量
                                    </th>
                                    <th rowspan="2">
                                        比例
                                    </th>
                                    <th rowspan="2">
                                        小计
                                    </th>
                                    <th colspan="2">
                                        其中
                                    </th>
                                </tr>
                                <tr>
                                    <th>一级</th>
                                    <th>二级</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>自用</td>
                                    <td>{{ totalVal.self_use_ratio }}%</td>
                                    <td>{{ totalVal.self_use_output }}</td>
                                    <td>{{ totalVal.first_grade_output }}</td>
                                    <td>{{ totalVal.second_grade_output }}</td>
                                </tr>
                                <tr>
                                    <td>外销</td>
                                    <td>{{ totalVal.export_ratio }}%</td>
                                    <td>{{ totalVal.export_output }}</td>
                                    <td>{{ totalVal.first_grade_export_output }}</td>
                                    <td>{{ totalVal.second_grade_export_output }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </v-touch>
</template>

<script>
import timeNodeFiltering from '@/components/timeNodeFiltering/index.vue';
import { lineChart } from '@/assets/js/charts';

export default {
    name: 'hlj-daily-production-report',
    components: { timeNodeFiltering },
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'hlj-daily-production-report');
        }
        next();
    },
    data() {
        return {
            navData: {
                title: '采矿生产日报',
                leftText: '',
                rightText: '',
                leftArrow: true,
            },
            // 唤起日期选择的日期key
            dateKey: '',
            listData: [], // 列表数据

            totalVal: {},
            tableData: [],
            lineChartData: [],
            time: {
                s: '',
                e: '',
            }, // 选择月份模式的开始结束日期
        };
    },
    created() {},
    methods: {
        // 获取数据
        async getData(start_date, end_date) {
            this.$toast.loading({ overlay: true, duration: 0 });
            const res = await this.getDataList(start_date, end_date);
            if (res) {
                this.totalVal = res.total;
                this.tableData = res.details;
                this.lineChartData = res.days;
                this.loadLineChart();
            }
            this.$toast.clear();
        },
        loadLineChart() {
            const xdata = this.lineChartData.map(item => item.report_date.substring(5, 10));
            const ydata = [{
                top: 70,
                color: ['#FA8436', '#FA8436', '#fff'],
                data: this.lineChartData.map(item => item.stripping_ratio),
            }];
            const chartData = {
                title: {
                    text: '剥离比7日曲线',
                    textStyle: {
                        fontSize: 16,
                        color: '#666666',
                        fontWeight: 'bold',
                    },
                },
                grid: {
                    top: 50,
                },
                xdata,
                borderColor: 'rgba(133,133,133,0.2)',
                fontColor: '#979EA7',
                ydata,
            };
            lineChart('balance-chart', chartData);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },

        // 获取数据
        getDataList(start_date, end_date) {
            const url = `/interfaceApi/report/report/ore/production/ore_day_report?start_date=${start_date}&end_date=${end_date}`;
            return this.$axios.$get(url, { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
.accountsReceive
    background #fff
    width 100%
    height calc(100vh - 70rpx)
    overflow-y: scroll
    .charts_header
        margin 12rpx 30rpx
        .van-tabs__nav
            margin 0
    .main
        .statisticsStyle1
            margin: 0 12rpx 5rpx
            border-radius 4rpx
            background repeating-linear-gradient(to left, #F79187, #EA5D5D)
            .header
                display flex
                justify-content: space-between
                flex-wrap: wrap;
                padding 10rpx 12rpx
                .item
                    padding 3rpx 0 5rpx 0
                    color #fff
                    &:nth-of-type(1)
                        width calc(100%/3)
                        position: relative
                        &:after
                            content ''
                            height: calc(100% - 20rpx)
                            width: 2px
                            background: rgba(255,255,255,0.2)
                            position: absolute
                            top 10rpx
                            right 0
                    .num2
                        font-size 18rpx
                        margin-top 6rpx
                    .describe2
                        font-size 14rpx
                        margin-bottom 3rpx
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        line-height 25rpx
        .statisticsStyle2
            margin:  0 12rpx
            display flex
            .item
                flex 1
                height: 40rpx;
                line-height 40rpx
                border-radius: 4px;
                border: 1px solid #FFFFFF;
                display flex
                justify-content center
                color #fff
                &:nth-of-type(1)
                    margin-right 5rpx
                    background: linear-gradient(270deg, #918F9E 0%, #6D6B7B 100%);
                &:nth-of-type(2)
                    background: linear-gradient(261deg, #A48171 0%, #7C5446 100%);
                .describe2
                    font-size 12rpx
                .num2
                    font-size 20rpx
        .chart-con
            padding 12rpx
            position relative
            .btn_box
                text-align: right
                button
                    border-radius: 4rpx
                    padding 0 12rpx
                    margin-left 5rpx
                    color #E93743
                    border: 1px solid #E93743;
                .xs_btn
                    border: none
                    background: linear-gradient(138deg, #EB6348 0%, #E93543 100%);
                    color #fff
            h4
                margin 10rpx 0
            #balance-chart
                height 260rpx
        .tableBox
            padding 0 12rpx 12rpx 12rpx
            width: 100%
            overflow-x: scroll
            table
                width 100%
                border-collapse: collapse
                th,td
                    height: 36rpx
                    color #343434
                    font-size 14rpx
                    border 1px solid #E4E4E4
                    text-align: center
                    padding 0 10rpx
                th
                    background: #FBEEEE
                    border-color #EAD9D9
</style>
